// Single source of truth for site-wide marketing config.
// SOCIAL_LINKS entries set to null are hidden everywhere they're consumed
// (currently the Footer) — drop real profile URLs in as accounts go live.
export const SITE_URL = 'https://pitchvault.co';

export const SITE_TAGLINE = 'Where Pitches Turn Into Paid Deals';

export const SOCIAL_LINKS = {
  tiktok: 'https://www.tiktok.com/@getpitchvault',
  instagram: 'https://www.instagram.com/getpitchvault',
  x: null, // pending handle decision on X
  youtube: 'https://www.youtube.com/@getpitchvault',
};

export const SOCIAL_LABELS = {
  tiktok: 'TikTok',
  instagram: 'Instagram',
  x: 'X',
  youtube: 'YouTube',
};
